import React, { useState, Suspense, createContext, useEffect } from 'react';
import './App.css';
import './fonts.css';
import './colors.css';
import "./Accordion.css";
import '../src/Pages/Appointment Scheduler/scheduler.css'
import AllRoutes from './routes/AllRoutes';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import '../node_modules/react-big-calendar/lib/css/react-big-calendar.css';
import ListingSkeleton from './Components/suspenceUi/ListingSkeleton';
import ChatAi from './Pages/chatAi/ChatAi';
import useReduxStore from './hooks/useReduxStore';
export const NotificationsState = createContext()
function App() {
  const [notificationcount, setNotificationcount] = useState(0)
  const [BudgeNotification, setBudgeNotification] = useState({
    waitingList: 1,
    requrestAppointment: 1
  })
  const [socket, setSocket] = useState(null)
  const [perioData, setPerioData] = useState({})
  const [missTeeth, setMissTeeth] = useState([])
  const [value, setValue] = useState(null)
  const { selector: user } = useReduxStore("auth")

  return (
    <>
      <ToastContainer limit={1} autoClose={1000} />
      <Suspense fallback={<ListingSkeleton listLength={10} />}>
        <div className="App">
          <NotificationsState.Provider value={{ BudgeNotification, setBudgeNotification, setNotificationcount, notificationcount, socket, setSocket, setPerioData, perioData, missTeeth, setMissTeeth, value, setValue }}>
            <AllRoutes />
            {user?.token && <ChatAi />}
          </NotificationsState.Provider>
        </div>
      </Suspense>
    </>
  );
}

export default App;
